import { render } from "./InfoAnnounce.vue?vue&type=template&id=75e42fbc&scoped=true"
import script from "./InfoAnnounce.vue?vue&type=script&lang=js"
export * from "./InfoAnnounce.vue?vue&type=script&lang=js"

import "./InfoAnnounce.vue?vue&type=style&index=0&id=75e42fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e42fbc"]])

export default __exports__